import React from 'react';

/**
 * Soft circular leaf decorations placed in page hero corners.
 * Pure-SVG, color-tinted to v2-green-100/200 — matches the reference hero design.
 */
export const LeafDecoration: React.FC<{ position?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right'; size?: number }> = ({
  position = 'top-left',
  size = 220,
}) => {
  const positionMap: Record<string, string> = {
    'top-left':     '-top-10 -left-[12.5rem]',
    'top-right':    '-top-10 -right-10',
    'bottom-left':  '-bottom-10 -left-10',
    'bottom-right': '-bottom-10 -right-10',
  };

  return (
    <div
      className={`absolute pointer-events-none ${positionMap[position]}`}
      style={{ width: size, height: size }}
      aria-hidden
    >
      <svg viewBox="0 0 200 200" className="w-full h-full">
        {/* Soft circle */}
        <circle cx="100" cy="100" r="100" fill="#D4F0DA" opacity="0.6" />
        {/* Inner accent */}
        {/* <circle cx="100" cy="100" r="60" fill="#A8E0B4" opacity="0.4" /> */}
      </svg>
    </div>
  );
};



